import { Injectable } from '@angular/core';

import { JsonConvert, OperationMode, ValueCheckingMode } from 'json2typescript';

@Injectable({
  providedIn: 'root',
})
export class Serializer {
  protected jsonConvert: JsonConvert;

  constructor() {
    this.jsonConvert = new JsonConvert();
    this.jsonConvert.operationMode = OperationMode.ENABLE;
    this.jsonConvert.ignorePrimitiveChecks = false;
    this.jsonConvert.valueCheckingMode = ValueCheckingMode.ALLOW_NULL;
  }

  toJson(instance: any): any {
    return this.jsonConvert.serializeObject(instance);
  }

  toJsonArray(instanceArray: any[]): any[] {
    return this.jsonConvert.serializeArray(instanceArray);
  }

  fromJson(json: any, classReference: new () => any): any {
    return this.jsonConvert.deserialize(json, classReference);
  }

  fromJsonArray(jsonArray: any[], classReference: new () => any): any[] {
    return this.jsonConvert.deserializeArray(jsonArray, classReference);
  }
}
